import moment from 'moment';

import { OfferStatus, OFFER_STATUS_LIST, ProductDimension } from '../../../models/offer';
import { PeriodIsoMonth } from '../../../models/month-week-value';
import { isoMonthParse } from '../../../models/iso-week-or-month-utils';

export function compareStr(st1?: string, st2?: string) {
	if (st1 && st2) {
		return st1.localeCompare(st2);
	}
	if (!st1 && !st2) {
		return 0;
	}
	return !st1 ? -1 : 1;
}

export function compareIdNbrStr(idN1?: number, idS1?: string, idN2?: number, idS2?: string) {
	if (idN1 !== undefined) {
		if (idN2 !== undefined) {
			return idN1 - idN2;
		}
		if (idS2 !== undefined) {
			return -1; // number before text
		}
		return 1; // undefined at first
	}
	if (idS1) {
		if (idN2 !== undefined) {
			return 1; // number before text
		}
		if (idS2) {
			return idS1.localeCompare(idS2);
		}
		return 1; // undefined at first
	}
	if (idN2 !== undefined || idS2) {
		return -1; // undefined at first
	}
	return 0;
}

export function comparePeriod(s1?: string, e1?: string, s2?: string, e2?: string) {
	if ((!s1 || !e1) && (!s2 || !e2)) {
		return 0;
	}
	if (!s1 || !e1) {
		return -1;
	}
	if (!s2 || !e2) {
		return 1;
	}
	const period1 = new PeriodIsoMonth(isoMonthParse(s1), isoMonthParse(e1));
	const period2 = new PeriodIsoMonth(isoMonthParse(s2), isoMonthParse(e2));
	return period1.compareWith(period2);
}

export function compareDate(d1?: Date, d2?: Date) {
	if (d1 && d2) {
		const m1 = moment(d1);
		const m2 = moment(d2);
		return m1.isBefore(m2) ? -1 : m1.isSame(m2) ? 0 : 1;
	}
	if (!d1 && !d2) {
		return 0;
	}
	return !d1 ? -1 : 1;
}

export function compareOfferStatus(s1: OfferStatus, s2: OfferStatus) {
	return OFFER_STATUS_LIST.indexOf(s1) - OFFER_STATUS_LIST.indexOf(s2);
}

export function compareNbr(n1?: number, n2?: number) {
	if (n1 !== undefined && n2 !== undefined) {
		return n1 - n2;
	}
	if (n1 === undefined && n2 === undefined) {
		return 0;
	}
	return n1 === undefined ? -1 : 1;
}

export function compareDimension(dim1?: ProductDimension, dim2?: ProductDimension) {
	if (dim1 && dim2) {
		const diffThickness = dim1.thickness.value - dim2.thickness.value;
		if (diffThickness !== 0) {
			return diffThickness;
		}
		const diffWidth = dim1.width.value - dim2.width.value;
		if (diffWidth !== 0) {
			return diffWidth;
		}
		return compareNbr(
			dim1.length ? dim1.length.value : undefined,
			dim2.length ? dim2.length.value : undefined
		);
	}
	if (!dim1 && !dim2) {
		return 0;
	}
	return !dim1 ? -1 : 1;
}
